import { Injectable } from "@angular/core";
import { HttpclientService, UserService } from "../../../shared";
import { BehaviorSubject, Subject } from "rxjs";
import { Observable } from "rxjs";
import { UserFavoritesRequest } from "./Info/UserFavoritesRequest";

@Injectable()
export class MenuService {
	constructor(private userService: UserService, private httpclientService: HttpclientService) {}

	private subject = new Subject<any>();

	private CollapseSubject = new BehaviorSubject("");
	CollapseObservable = this.CollapseSubject.asObservable();

	CollapseMenu(data: any) {
		this.CollapseSubject.next(data);
	}

	getApplicationItems() {
		var promise$ = this.httpclientService.post("Security/ApplicationItemGetList", null);
		return promise$;
	}

	ApplicationItemGetList() {
		var postResult$ = new Subject();
		var url = "Security/ApplicationItemGetList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CheckMenuList(): Observable<any> {
		return this.subject.asObservable();
	}

	MenuIsLoaded(loaded, lstRouterLink: string[]) {
		this.subject.next({ isloaded: loaded, lstRouterLink: lstRouterLink });
	}

	//
	//Navbar messages
	//
	BroadcastAlertTodaySelectList(userID) {
		var postResult$ = new Subject();
		var url = "Dashboard/BroadcastAlertTodaySelectList?UserID=" + userID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetAlertsRefreshMinutes() {
		var postResult$ = new Subject();
		var url = "Dashboard/GetAlertsRefreshMinutes?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetCAASSVersion() {
		var postResult$ = new Subject();
		var url = "Dashboard/GetCAASSVersion?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserFavoriteDeleteByID(parms: UserFavoritesRequest) {
		var postResult$ = new Subject();
		var url = "Dashboard/UserFavoriteDeleteByID";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	//////////////////////////////////////////////////////////////////////////
	// Refresh Menu when it changes (10.11)
	//////////////////////////////////////////////////////////////////////////
	private MenuRefreshAllSubject = new BehaviorSubject("");
	MenuRefreshAllObservable = this.MenuRefreshAllSubject.asObservable();

	MenuRefreshAll(data: any) {
		this.MenuRefreshAllSubject.next(data);
	}

	private MenuRefreshFavoritesSubject = new BehaviorSubject("");
	MenuRefreshFavoritesObservable = this.MenuRefreshFavoritesSubject.asObservable();

	MenuRefreshFavorites(data: any) {
		this.MenuRefreshFavoritesSubject.next(data);
	}

	private CheckFavoriteTopBarSubject = new BehaviorSubject("");
	CheckFavoriteTopBarObservable = this.CheckFavoriteTopBarSubject.asObservable();

	CheckFavoriteTopBar(data: any) {
		this.CheckFavoriteTopBarSubject.next(data);
	}

	//////////////////////////////////////////////////////////////////////////

	private subjectInboxChanged = new Subject<any>();
	inboxChanged(params) {
		this.subjectInboxChanged.next(params);
	}

	onInboxChange(): Observable<any> {
		return this.subjectInboxChanged.asObservable();
	}

	private subjectReportInboxChanged = new Subject<any>();
	reportInboxChanged(params) {
		this.subjectReportInboxChanged.next(params);
	}

	onReportInboxChange(): Observable<any> {
		return this.subjectReportInboxChanged.asObservable();
	}

	// NOTE: Uses Current User ID (Probably from Common Controller or Common Data)
	InboxCountSelect() {
		var postResult$ = new Subject();
		var url = "SBMInbox/InboxCountSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	Top5SelectAnyError(SchoolID) {
		var postResult$ = new Subject();
		var url = "Dashboard/Top5SelectAnyError?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MasterPreferencesSelect() {
		var postResult$ = new Subject();
		var url = "api/token/MasterPreferencesSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	CurrentRoleTooltipSelect() {
		var postResult$ = new Subject();
		var url = "Dashboard/CurrentRoleTooltipSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SBMEnabledSelect() {
		var postResult$ = new Subject();
		var url = "Dashboard/SBMEnabledSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReportInboxCountSelect() {
		var postResult$ = new Subject();
		var url = "ReportInbox/InboxCountSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
